<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ac967j/image/9781398433922_FC.jpg?1684571217723" alt="This image is the cover for the book Shadows & Angels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shadows & Angels
      </h1>
      <p class="bookDescription body article font2">
        <p>What happens when mysterious stories of the world’s light as well as strange, secretive and sometimes macabre tales of its darkness collide in spectacular fashion? Shadows &amp; Angels is just such a haunting, distinctive and contrasting poetry collection. It takes the reader on an exhilarating roller coaster journey of the good, bad and ugly side of life’s experiences; sometimes hurtling back centuries in time, before rebounding into the present, with a veritable cornucopia of subject matter. Poetic and varied images of dark fantasy and horror are merged with love, romance, and dazzling optimism; beguiling lyrical rhyme, hammering on the doors of broken rules, blends inexorably with a myriad of profound emotions; as terrifying monsters, both real and metaphorical, battle with wise, courageous angels for supremacy in the moving narrative. Charming, enigmatic and complex characters in abundance are introduced as this mesmerising book leads its readers across the winding annals of time, continents and differing worlds. From supernatural to beautiful and fantastical to dangerous, with hypnotic and seductive chronicles, shocking plot twists and radiant intensity: each poem imbibes emotive reflection told in an elegant and powerful language that engages the reader in intelligent and stylish prose, whilst making them imagine they are clandestine observers in each dramatic scene. Whether opening the gates of Hell or peppering murky dreams with unrequited love, doomed romance or echoing periods of high-impact drama and wondrous adventure, Shadows &amp; Angels conveys a rare, intelligent and perceptive insight into a world of intrigue and jeopardy, but always encompassed in warrior resilience and precious hope.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul James
      </h2>
      
      <p class="authorDescription body article">Paul James hails from Yorkshire and is now settled in London. He has led an eclectic mix of an existence, living and working on four continents. A former military man; aircraft engineer; semi-pro footballer; national security consultant; international businessman; poet and published author, Paul is an incurable primeval Scorpio romantic, with an artistic penchant for the ocean-deep intensity and surreal dark side in his writing, where he pushes the boundaries of poetic prose. His passionate nature and old-fashioned soul are as prevalent in his life as they are in his studious work, showcased in this unique poetry collection.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?568701de